import Swiper from 'swiper';
import { Autoplay, Navigation} from 'swiper';
import { getDisplayMode } from '../common/libs.js';

const setBannerSlider = () => {
  const targetSliders = document.querySelectorAll(".js-banner-slider");

  targetSliders.forEach(bannerSlider => {
    const slideLength = bannerSlider?.querySelectorAll(".swiper-slide").length;
    let first = false;
    let windowWidth = bannerSlider?.clientWidth;
    let slideSize = 0;
    let slideSpace = 0;
    if (getDisplayMode() == 1) {
      slideSize = 250;
      slideSpace = 15;
    } else {
      slideSize = 160;
      slideSpace = 10;
    }
    let viewSlideLength = Math.floor(windowWidth / (slideSize + slideSpace));


    if (slideLength > viewSlideLength) {
      var swiper = new Swiper(bannerSlider, {
        modules: [Autoplay,Navigation],
        autoplay: {
          disableOnInteraction: false,
        },
        speed: 500,
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: slideSpace,
        // centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    } else {
      bannerSlider?.classList.add('slide-none');

      const navButtons = bannerSlider.closest('.section-content')?.querySelector('.swiper-button-wrapper');
      navButtons?.classList.add('slide-none');

    }
    bannerSlider?.classList.add('is-init')
  })
}

export default setBannerSlider;